import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { PageContent, Container, Table, Spinner, Alert, Alerts, ButtonAction } from 'components';
import { loadUserExamDiplomasCreator, downloadUserExamDiplomaCreator } from 'store/actionsCreators';
import { isLoading } from 'helpers';
import { formatDate } from 'helpers/date';
import Actions from './Diplomas.styled';

const COLUMN_COUNT = 4;

const Diplomas = ({ loading, items, loadList, downloadDiploma }) => {
  const { t } = useTranslation();

  useEffect(() => {
    loadList();
  }, []);

  return (
    <PageContent>
      <Container>
        <Alerts type="user" />
        <Table tablebreakpoint="lg">
          <Table.Head>
            <Table.Row>
              <Table.Heading>{t('page.user.courses.diplomas.tableExam')}</Table.Heading>
              <Table.Heading>{t('page.user.courses.diplomas.tableDate')}</Table.Heading>
              <Table.Heading>{t('page.user.courses.diplomas.tableControlNumber')}</Table.Heading>
              <Table.Heading>{t('page.user.courses.diplomas.tableActions')}</Table.Heading>
            </Table.Row>
          </Table.Head>
          <Table.Body>
            {loading ? (
              <Table.Row>
                <Table.Cell colSpan={COLUMN_COUNT}>
                  <Spinner />
                </Table.Cell>
              </Table.Row>
            ) : null}
            {!loading && !items.length ? (
              <Table.Row>
                <Table.Cell colSpan={COLUMN_COUNT}>
                  <Alert type="info">{t('page.user.courses.diplomas.noResults')}</Alert>
                </Table.Cell>
              </Table.Row>
            ) : null}
            {!loading && items.length
              ? items.map((item) => (
                  <Table.Row key={item.id}>
                    <Table.Cell>
                      <Table.Label>{t('page.user.courses.diplomas.tableExam')}:</Table.Label>
                      {item.exam ? item.exam.title : ''}
                    </Table.Cell>
                    <Table.Cell>
                      <Table.Label>{t('page.user.courses.diplomas.tableDate')}:</Table.Label>
                      {item.completedAt ? formatDate(item.completedAt) : ''}
                    </Table.Cell>
                    <Table.Cell>
                      <Table.Label>
                        {t('page.user.courses.diplomas.tableControlNumber')}:
                      </Table.Label>
                      {item.controlNumber || '-'}
                    </Table.Cell>
                    <Table.Cell middle>
                      <Table.Label>{t('page.user.courses.diplomas.tableActions')}:</Table.Label>
                      <Actions>
                        <ButtonAction
                          icon="download"
                          title={t('page.user.courses.diplomas.download')}
                          onClick={() =>
                            downloadDiploma({
                              id: item.id,
                              name: item.exam ? item.exam.title : '',
                            })
                          }
                        />
                        {item.badgeUrl ? (
                          <ButtonAction
                            as="a"
                            href={item.badgeUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            icon="badge"
                            title={t('page.user.courses.diplomas.viewBadge')}
                          />
                        ) : null}
                      </Actions>
                    </Table.Cell>
                  </Table.Row>
                ))
              : null}
          </Table.Body>
        </Table>
      </Container>
    </PageContent>
  );
};

Diplomas.propTypes = {
  loading: PropTypes.bool,
  items: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  loadList: PropTypes.func.isRequired,
  downloadDiploma: PropTypes.func.isRequired,
};

Diplomas.defaultProps = {
  loading: false,
};

const mapStateToProps = ({ loading, user }) => ({
  loading: isLoading(loading, 'LOAD_USER_EXAM_DIPLOMAS'),
  items: user.courses.diplomas.items,
});

const mapDispatchToProps = (dispatch) => ({
  loadList: () => dispatch(loadUserExamDiplomasCreator()),
  downloadDiploma: (payload) => dispatch(downloadUserExamDiplomaCreator(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Diplomas);
